/**
 * Блокировки — чтение из реплики.
 */
import { blocksRepo, useReplica } from '@shared/db'

export function useBlockedUserIds(): string[] {
  return useReplica(() => blocksRepo.all(), [], [])
}
